package com.willandsons.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.ColorPalettes
import com.willandsons.SubheadlineTextStyle
import com.willandsons.components.layouts.PageLayoutData
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

// Container that has a tagline and grid on desktop, and just the tagline on mobile
val HeroContainerStyle = CssStyle {
    base { Modifier.fillMaxWidth().gap(2.cssRem).margin { bottom(20.vh) } }
    Breakpoint.MD { Modifier.margin { top(20.vh) } }
}

val HomeImageStyle = CssStyle.base {
    Modifier
        .width(70.cssRem)
        .height(18.cssRem)
}

@InitRoute
fun initHomePage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("About"))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun HomePage() {
    Row(HeroContainerStyle.toModifier()) {
        Box {

            Column(Modifier.gap(2.cssRem)) {
                SpanText(
                    "I created this company to leverage the potential of my family—mine and my sons'. We have started implementing new ideas that make people's lives easier, whether in everyday aspects of life or just for entertainment.\n" +
                            "I encourage everyone to download and use our apps with confidence; you will enjoy them.",
                    Modifier.color(
                        when (ColorMode.current) {
                            ColorMode.LIGHT -> Colors.Black
                            ColorMode.DARK -> Colors.White
                        }
                    )
                )

                Div(SubheadlineTextStyle.toAttrs()) {
                    SpanText("Best regards, Grosz Vilmos")
                }

                val ctx = rememberPageContext()
                Button(onClick = {
                    // Change this click handler with your call-to-action behavior
                    // here. Link to an order page? Open a calendar UI? Play a movie?
                    // Up to you!
                    ctx.router.tryRoutingTo("/apps")
                }, colorPalette = ColorPalettes.Blue) {
                    Text("See Our Apps")
                }
            }
        }

        Div(
            HomeImageStyle
                .toModifier()
                .displayIfAtLeast(Breakpoint.MD)
                .toAttrs()
        ) {
            Image(
                "/portrait.jpeg",
                "Picture of Grosz Vilmos",
                Modifier
                    .fillMaxSize()
                    .objectFit(ObjectFit.Cover)
                    .borderRadius(1.cssRem)
            )
        }
    }
}
